import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, Plus, Search, Filter } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { useNavigate } from 'react-router-dom';
export function AuctionManagementPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [sortBy, setSortBy] = useState('date');
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const auctions = [{
    id: 'AUC-001',
    loc: 'Hinjewadi Ph 3',
    plot: 'Plot #42 (Comm)',
    base: '₹1.2 Cr',
    baseValue: 12000000,
    curr: '₹1.45 Cr',
    currValue: 14500000,
    bids: 12,
    date: 'Oct 25, 2024',
    dateValue: new Date('2024-10-25'),
    status: 'Active'
  }, {
    id: 'AUC-002',
    loc: 'Wagholi',
    plot: 'Plot #18 (Resi)',
    base: '₹85 L',
    baseValue: 8500000,
    curr: '₹85 L',
    currValue: 8500000,
    bids: 0,
    date: 'Oct 28, 2024',
    dateValue: new Date('2024-10-28'),
    status: 'Upcoming'
  }, {
    id: 'AUC-003',
    loc: 'Baner',
    plot: 'Plot #05 (Mixed)',
    base: '₹3.5 Cr',
    baseValue: 35000000,
    curr: '₹4.1 Cr',
    currValue: 41000000,
    bids: 28,
    date: 'Oct 20, 2024',
    dateValue: new Date('2024-10-20'),
    status: 'Closed'
  }, {
    id: 'AUC-004',
    loc: 'Kharadi',
    plot: 'Plot #12 (Comm)',
    base: '₹2.8 Cr',
    baseValue: 28000000,
    curr: '₹3.2 Cr',
    currValue: 32000000,
    bids: 15,
    date: 'Oct 26, 2024',
    dateValue: new Date('2024-10-26'),
    status: 'Active'
  }, {
    id: 'AUC-005',
    loc: 'Wakad',
    plot: 'Plot #07 (Resi)',
    base: '₹1.5 Cr',
    baseValue: 15000000,
    curr: '₹1.5 Cr',
    currValue: 15000000,
    bids: 0,
    date: 'Nov 01, 2024',
    dateValue: new Date('2024-11-01'),
    status: 'Upcoming'
  }];
  let filteredAuctions = auctions.filter(auction => {
    const matchesSearch = auction.id.toLowerCase().includes(searchQuery.toLowerCase()) || auction.loc.toLowerCase().includes(searchQuery.toLowerCase()) || auction.plot.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'All' || auction.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  // Sort auctions
  if (sortBy === 'date') {
    filteredAuctions = [...filteredAuctions].sort((a, b) => a.dateValue.getTime() - b.dateValue.getTime());
  } else if (sortBy === 'price') {
    filteredAuctions = [...filteredAuctions].sort((a, b) => b.currValue - a.currValue);
  } else if (sortBy === 'bids') {
    filteredAuctions = [...filteredAuctions].sort((a, b) => b.bids - a.bids);
  }
  const handleCreateAuction = () => {
    navigate('/authority/auctions/create');
  };
  const handleManage = (auctionId: string) => {
    navigate(`/authority/auctions/${auctionId}`);
  };
  return <DashboardLayout title="Auction Management" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2424">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-2425">
        <div data-id="element-2426">
          <h1 className="text-2xl font-bold mb-1" data-id="element-2427">Land Auctions</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-2428">
            Manage public land auctions and bidding processes.
          </p>
        </div>
        <button onClick={handleCreateAuction} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2429">
          <Plus className="w-4 h-4" data-id="element-2430" /> Create New Auction
        </button>
      </div>

      {/* Filters - NOW WORKING */}
      <div className="bg-white border border-gray-300 p-4 mb-6 flex flex-col md:flex-row gap-4 items-center justify-between" data-id="element-2431">
        <div className="relative w-full md:w-96" data-id="element-2432">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-2433" />
          <input type="text" placeholder="Search by Plot ID or Location..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-9 pr-4 py-2 border border-gray-300 bg-gray-50 text-sm focus:outline-none focus:border-gray-500" data-id="element-2434" />
        </div>
        <div className="flex gap-2 w-full md:w-auto" data-id="element-2435">
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-3 py-2 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2436">
            <option value="All" data-id="element-2437">All Status</option>
            <option value="Active" data-id="element-2438">Active</option>
            <option value="Upcoming" data-id="element-2439">Upcoming</option>
            <option value="Closed" data-id="element-2440">Closed</option>
          </select>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="px-3 py-2 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2441">
            <option value="date" data-id="element-2442">Sort: Date</option>
            <option value="price" data-id="element-2443">Sort: Price</option>
            <option value="bids" data-id="element-2444">Sort: Bids</option>
          </select>
        </div>
      </div>

      {/* Auctions Table */}
      <div className="bg-white border border-gray-300 overflow-hidden" data-id="element-2445">
        <div className="overflow-x-auto" data-id="element-2446">
          <table className="w-full text-left text-sm min-w-[800px]" data-id="element-2447">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-2448">
              <tr data-id="element-2449">
                <th className="p-4 font-bold" data-id="element-2450">Auction ID</th>
                <th className="p-4 font-bold" data-id="element-2451">Location / Plot</th>
                <th className="p-4 font-bold" data-id="element-2452">Base Price</th>
                <th className="p-4 font-bold" data-id="element-2453">Current Bid</th>
                <th className="p-4 font-bold" data-id="element-2454">Bidders</th>
                <th className="p-4 font-bold" data-id="element-2455">Closing Date</th>
                <th className="p-4 font-bold" data-id="element-2456">Status</th>
                <th className="p-4 font-bold text-right" data-id="element-2457">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2458">
              {filteredAuctions.map((item, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-2459">
                  <td className="p-4 font-mono font-bold" data-id="element-2460">{item.id}</td>
                  <td className="p-4" data-id="element-2461">
                    <div className="font-bold" data-id="element-2462">{item.loc}</div>
                    <div className="text-xs text-gray-500 font-mono" data-id="element-2463">
                      {item.plot}
                    </div>
                  </td>
                  <td className="p-4 font-mono" data-id="element-2464">{item.base}</td>
                  <td className="p-4 font-mono font-bold text-green-700" data-id="element-2465">
                    {item.curr}
                  </td>
                  <td className="p-4 font-mono" data-id="element-2466">{item.bids}</td>
                  <td className="p-4 font-mono text-xs" data-id="element-2467">{item.date}</td>
                  <td className="p-4" data-id="element-2468">
                    <span className={`inline-block px-2 py-1 text-xs font-bold rounded border ${item.status === 'Active' ? 'bg-green-100 text-green-800 border-green-200' : item.status === 'Upcoming' ? 'bg-blue-100 text-blue-800 border-blue-200' : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-id="element-2469">
                      {item.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4 text-right" data-id="element-2470">
                    <button onClick={() => handleManage(item.id)} className="text-blue-600 hover:underline font-bold text-xs" data-id="element-2471">
                      Manage
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {filteredAuctions.length === 0 && <div className="p-12 text-center text-gray-500" data-id="element-2472">
            <p className="font-mono text-sm" data-id="element-2473">
              No auctions found matching your criteria
            </p>
          </div>}
      </div>
    </DashboardLayout>;
}